import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import ProtectedRoute from '@/components/routes/ProtectedRoute';
import AppRoutes, { defaultRouter } from '@/routers/globalRouters';

import { AppCurrentUserModel, hasPermissions } from '@/services/roleService';

export default function renderRoutes(auth: AppCurrentUserModel | null) {
  return (
    <Switch>
      {AppRoutes.filter(x => hasPermissions(x.permissions, auth)).map((r, idx) => {
        return <ProtectedRoute key={idx} {...r} />;
      })}

      <Redirect from="*" to={defaultRouter} />
    </Switch>
  );
}
